import React from 'react';
import { ShoppingBagIcon, PackageIcon, LayersIcon, BarChart3Icon, TruckIcon, TagIcon, RepeatIcon, ShieldCheckIcon, PaletteIcon, ClipboardCheckIcon, UsersIcon, GlobeIcon } from 'lucide-react';
import { SolutionPageLayout } from '../../components/SolutionPageLayout';
const features = [{
  icon: LayersIcon,
  title: 'Product Configuration',
  description: 'Manage complex product variants with attributes like size, color, material, and finish. Define BOMs and routings per configuration without duplicating master data.'
}, {
  icon: PackageIcon,
  title: 'Kitting & Assembly',
  description: 'Build kits and assembled products from component inventory. Support both pre-built and assemble-to-order workflows with real-time component availability.'
}, {
  icon: TagIcon,
  title: 'Lot Traceability & Compliance',
  description: 'Full lot and batch traceability from raw material to finished product. Meet regulatory requirements for consumer safety, labeling, and recall readiness.'
}, {
  icon: TruckIcon,
  title: 'Order Fulfillment',
  description: 'Manage the pick, pack, and ship process with barcode scanning and carrier integration. Support B2B, B2C, and marketplace fulfillment from a single system.'
}, {
  icon: ShoppingBagIcon,
  title: 'E-Commerce Integration',
  description: 'Connect to Shopify, Amazon, and other sales channels. Sync orders, inventory, and product data in real time to prevent overselling and delays.'
}, {
  icon: BarChart3Icon,
  title: 'Demand Planning',
  description: 'Forecast demand based on historical sales, seasonality, and promotions. Align production and purchasing plans with expected demand to avoid stockouts.'
}, {
  icon: RepeatIcon,
  title: 'Returns & RMA Processing',
  description: 'Manage customer returns with reason tracking, inspection workflows, and disposition decisions. Process refunds, replacements, or restocking efficiently.'
}, {
  icon: ShieldCheckIcon,
  title: 'Quality & Testing',
  description: 'Define quality specifications and testing protocols for consumer products. Track test results, manage holds, and ensure only conforming product ships.'
}, {
  icon: PaletteIcon,
  title: 'Packaging & Labeling',
  description: 'Manage packaging BOMs, label templates, and regulatory markings. Support multiple packaging configurations for different channels and markets.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Regulatory Compliance',
  description: 'Track certifications, testing requirements, and regulatory submissions. Maintain documentation for FDA, CPSC, EU, and other regulatory bodies.'
}, {
  icon: UsersIcon,
  title: 'Vendor & Co-Manufacturer Management',
  description: 'Coordinate with contract manufacturers and suppliers. Share specifications, track production status, and manage quality across your supply network.'
}, {
  icon: GlobeIcon,
  title: 'Multi-Channel Inventory',
  description: 'Allocate and manage inventory across retail, wholesale, DTC, and marketplace channels. Prevent overselling with real-time availability across all channels.'
}];
export function ConsumerProductsPage() {
  return <SolutionPageLayout label="Complex Consumer Products" title="From formulation to fulfillment — one system" subtitle="Consumer products companies deal with variants, regulations, and multi-channel complexity. Thruline builds the operational system that keeps it all connected." features={features} data-id="element-398" />;
}